<template>
<div class="d-flex flex-column" id="app" :class="{'dark-mode': darkMode}">
  <main class="flex-fill">
    <app-header :position="isScrolled" :class="{'navbar-light': !darkMode, 'navbar-dark': darkMode}" @toggleMode="darkMode = !darkMode"></app-header>
    <message-component></message-component>
    <div class="row m-0">
      <div class="col-lg-10 offset-lg-2 p-3">
        <router-view></router-view>
      </div>
    </div>
  </main>
</div>
</template>

<script>
import Header from './components/Header.vue'
import MessageComponent from './components/common/MessageComponent.vue'
export default {
  components: {
    appHeader: Header,
    MessageComponent
  },
  data () {
    return {
      darkMode: false,
      isScrolled: 'top'
    }
  },
  beforeMount () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (window.scrollY > 10) {
        this.isScrolled = 'scrolled'
      } else {
        this.isScrolled = 'top'
      }
    }
  }
}
</script>

<style>
#app {
  background-color: var(--light-color-off);
  min-height: 100vh;
  font-weight: 400;
  color: var(--dark-color);
}
#app.dark-mode  {
  background-color: var(--dark-color);
  color: var(--light-color);
  font-weight: 300;
}
  #reset-store-panel {
    position: fixed; bottom: 0px; right: 0px;
  }

  body, .sticky-footer-wrapper {
     min-height:100vh;
  }

  .flex-fill {
     flex:1 1 auto;
  }
  footer {
    height: 40px;
    color: #666;
    padding: 10px 0 10px 0;
    font-size: 85%;
  }
  footer a {
    color: #999;
  }
  footer a:hover {
    color: #efefef;
  }
  @media (max-width: 576px) {
    footer {
      height: 50px;
    }
  }
</style>
